import { _DICC_ESCUELA } from "../../../../data/modulo/Escuela";
import { ISearchProvider, ISearchResult } from "../../../../ui/components-lit/GlobalSearch/types";
import { TGlobalSearchProviderContext } from "./provider.types";

export const createEscuelaProvider = (ctx: TGlobalSearchProviderContext): ISearchProvider => {
    return {
        key: "escuela",
        label: "Escuelas",
        subLabel: "Gestión de escuelas",
        action: ctx.navigateModule("escuelas/escuelas"),
        search: (query: string): ISearchResult[] => {
            const category = "Escuelas";

            return Array.from(_DICC_ESCUELA.values())
                .filter((escuela) => {
                    const schoolName = escuela.Nombre || "";
                    const idValue = String(escuela.IdKinder);
                    return ctx.filter(query, idValue, [schoolName, category]);
                })
                .map<ISearchResult>((escuela) => ({
                    id: `escuela-${escuela.IdKinder}`,
                    title: escuela.Nombre || `Escuela ${escuela.IdKinder}`,
                    subtitle: `ID ${escuela.IdKinder}`,
                    category,
                    action: ctx.navigatePanel("escuelas/escuelas/panel", escuela.IdKinder),
                }));
        },
    };
};
